// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../../styles/variables.css\"","textDefault":"#808080","wrapper":"_2qyfQx9ShkHDQSiRhMou31","title":"-kTJKma2_8Cy7e4yhlGO3","question":"atGdrVKzrI5G1tiST6zCc","button-section":"_3QTmq3sM6q7X9cZR81VkZ-"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Module/components/CheckInInvitation.mod.css
// module id = 1568
// module chunks = 0